import { Flex } from 'antd';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import UncontrolledAccionaTable from '../../../../../../../components/AccionaTable/UncontrolledTable';
import MashControlBadge from '../../../CustomTraceabilityList/components/MashControlBadge';
import { Link, useOutletContext } from 'react-router-dom';
import styles from './index.module.scss';

const { link } = styles;

const BatchDeliveryTable = ({ data }) => {
  const intl = useIntl();
  const { project } = useOutletContext();

  return (
    <UncontrolledAccionaTable
      columns={{
        batch_code: {
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.batch_code',
            defaultMessage: 'Código lote',
          }),
          dataIndex: 'batch_code',
          key: 'batch_code',
          align: 'center',
        },
        docket_number: {
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.docket_number',
            defaultMessage: 'Albarán',
          }),
          dataIndex: 'docket_number',
          key: 'docket_number',
        },
        arriving_date: {
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.arriving_date',
            defaultMessage: 'Fecha entrega',
          }),
          dataIndex: 'arriving_date',
          key: 'arriving_date',
          align: 'center',
        },
        structural_element: {
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.structural_element',
            defaultMessage: 'Elemento estructural',
          }),
          dataIndex: 'structural_element',
          key: 'structural_element',
          align: 'center',
        },
        batch_volume: {
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.batch_volume',
            defaultMessage: 'Volumen lote [m³]',
          }),
          dataIndex: 'batch_volume',
          key: 'batch_volume',
          align: 'center',
        },
        detailed_location: {
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.detailed_location',
            defaultMessage: 'Ubicación detallada',
          }),
          dataIndex: 'detailed_location',
          key: 'detailed_location',
        },
      }}
      items={data || []}
      showPagination={false}
      total={data?.length}
      pageSize={data?.length}
      dataParseFunction={(data) =>
        data.map((d) => ({
          ...d,
          rawData: d,
          batch_code:
            project.version === 1
              ? d.batch_code
              : `${d.tag_batch_data?.tag_data.name} ${d.tag_batch_data?.tag_number}`,
          batch_volume: d.batch_volume?.toFixed(2),
          docket_number: (
            <Flex gap={5}>
              <Link
                to={`../../ocr/scannedDocuments/scannedDocumentsRC/validated/${d.id}`}
                className={link}
              >
                {d.docket_number}
              </Link>{' '}
              <MashControlBadge />
            </Flex>
          ),
        }))
      }
    />
  );
};

BatchDeliveryTable.propTypes = {
  data: PropTypes.array,
};

BatchDeliveryTable.defaultProps = {
  data: [],
};

export default BatchDeliveryTable;
